import { ChakraProvider } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';
import { MetadataProvider } from '@/providers/Metadata.provider';
import { setupStore } from '@/store';
import theme from '@/theme';

import './i18n';

import '@/global.css';

Sentry.init({
  dsn: process.env.REACT_APP_GLITCH_TIP_DSN,
  environment:
    process.env.NODE_ENV === 'production' ? 'production' : 'development',
});

const store = setupStore();

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={store}>
    <MetadataProvider />

    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
